<template>
  <v-card
    class="mx-auto"
    tile
  >
    <v-img
      height="240px"
      src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
      gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
    >
      <v-row
        justify="space-around"
      >
        <v-col
          cols="4"
        >
          <v-container>
            <v-avatar
              color="grey"
              size="100"
            >
              <v-img src="https://vignette.wikia.nocookie.net/topgear/images/d/d2/White_Stig.jpg/revision/latest?cb=20190611114041"></v-img>
            </v-avatar>
          </v-container>
        </v-col>
        <v-col
          align-self="center"
          cols="4"
          class="display-3"
        >
          <v-list-item
            color="rgba(0, 0, 0, .4)"
            dark
          >
            <v-list-item-content class="text-center">
              <v-list-item-title class="title">12,123</v-list-item-title>
              <v-list-item-subtitle>Posts</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col
          align-self="center"
          cols="4"
          class="display-3"
        >
          <v-list-item
            color="rgba(0, 0, 0, .4)"
            dark
          >
            <v-list-item-content class="text-center">
              <v-list-item-title class="title">16,387</v-list-item-title>
              <v-list-item-subtitle>Kudos</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col class="py-0">
          <v-list-item
            color="rgba(0, 0, 0, .4)"
            dark
          >
            <v-list-item-content>
              <v-list-item-title class="title">The Stig</v-list-item-title>
              <v-list-item-subtitle>Dungeon Master</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-img>
    <v-card-title>
      <div>Overview</div>
    </v-card-title>
  </v-card>
</template>

<script>
  export default {
    name: 'Profile'
  };
</script>

<style scoped>

</style>
